import React from "react";
import "./Loader.css"; // Dodajemo CSS za animaciju

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="spinner"></div>
      <p>Učitavanje...</p>
    </div>
  );
};

export default Loader;